export default function usePriceToggle() {
  const { $sitewideConfig } = useNuxtApp()

  const priceToggle = useCookie('price-toggle', {
    default: () => false,
    maxAge: getSecondsToMidnight(),
  })

  function togglePrices() {
    priceToggle.value = !priceToggle.value
  }

  function getSecondsToMidnight() {
    const now = new Date()
    const tomorrow = new Date(now)
    tomorrow.setDate(tomorrow.getDate() + 1)
    tomorrow.setHours(0, 0, 0, 0)

    const seconds = Math.floor((tomorrow.getTime() - now.getTime()) / 1000)
    return seconds
  }

  const isPriceEnabled = computed(() => {
    if ($sitewideConfig.config.nonTransactionalEnabled) return priceToggle.value
    return true
  })

  return {
    isPriceEnabled,
    togglePrices,
  }
}
